import { render, staticRenderFns } from "./PopupNewClassTimeTable.vue?vue&type=template&id=13d3b867&scoped=true"
import script from "./PopupNewClassTimeTable.vue?vue&type=script&lang=js"
export * from "./PopupNewClassTimeTable.vue?vue&type=script&lang=js"
import style0 from "./PopupNewClassTimeTable.vue?vue&type=style&index=0&id=13d3b867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3b867",
  null
  
)

export default component.exports